import React, {useEffect} from 'react';
import {useShallow} from 'zustand/react/shallow';
import {useStudentDashboard} from '../StudentDashboard.store';
import {Button, Dialogue, Modal, Icon} from '@albert-io/atomic';

const HardCapStudentErrorModal = () => {
  const {setExceededHardCapLimit} = useStudentDashboard(
    useShallow((state) => ({
      setExceededHardCapLimit: state.setExceededHardCapLimit
    }))
  );

  useEffect(() => {
    return () => {
      setExceededHardCapLimit(false);
    };
  }, [setExceededHardCapLimit]);

  return (
    <Modal handleClose={() => setExceededHardCapLimit(false)} ariaLabel='seats already taken'>
      {({CloseButtonWrapper}) => (
        <Dialogue inModal hideCloseBtn className='u-color_slate-500 text-center' size='s'>
          <div className='hard-cap-error__student-icon'>
            <Icon icon={['fal', 'face-surprise']} />
          </div>
          <p className='block'>
            Unfortunately, we couldn&apos;t add you to this classroom because all the seats are
            already taken. Sorry about that!
          </p>
          <p className='u-mar-b_3 block'>
            Contact your teacher for help. They&apos;ll be able to assist you further.
          </p>
          <CloseButtonWrapper className='u-width_100pc'>
            <Button variant='outlined' onClick={() => setExceededHardCapLimit(false)}>
              Dismiss
            </Button>
          </CloseButtonWrapper>
        </Dialogue>
      )}
    </Modal>
  );
};

export default HardCapStudentErrorModal;
